import { render } from "./Referencia.vue?vue&type=template&id=a5521e82&scoped=true"
import script from "./Referencia.vue?vue&type=script&lang=js"
export * from "./Referencia.vue?vue&type=script&lang=js"

import "./Referencia.vue?vue&type=style&index=0&id=a5521e82&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=a5521e82&scoped=true&lang=css"
import "./Referencia.vue?vue&type=style&index=2&id=a5521e82&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5521e82"]])

export default __exports__